import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ModuleLayout from '../../layout/ModuleLayout';
import { useTranslation } from 'react-i18next';
import {
  FaTachometerAlt
} from 'react-icons/fa';

// Import components
import Dashboard from '../Dashboard';

const DashboardModule = () => {
  const { t } = useTranslation();

  const moduleConfig = {
    id: 'dashboard',
    title: t('modules.dashboard.title'),
    description: t('modules.dashboard.description'),
    icon: FaTachometerAlt,
    color: '#007bff',
    menuItems: [
      { path: '/dashboard', icon: FaTachometerAlt, label: t('nav.dashboard') }
    ]
  };

  return (
    <ModuleLayout moduleConfig={moduleConfig}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
      </Routes>
    </ModuleLayout>
  );
};

export default DashboardModule;
